import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister"
import cx from "classnames";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import ModalVideo from "../modal-video/component";
import ModalMarket from "../modal-market/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import {agentRegister} from "../../services/agentRegister";

class HeaderMobileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            options: {
                home: false,
                advertise: false,
                about: false
            },
            menu: false,
            layout: false,
            dropwdown: false,
            temp_lang: null,
            language: false,
            leave: false,
            home: false,
            profile: false,
            market: null,
            marketModal: false,
            temp_market: null,
            languages: [],
            markets: [],
            temp_option: null,
            private: false
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
        this._setVideo = this._setVideo.bind(this);
    };

    componentWillMount() {
        this._updateLayout();
        this._updateUser();
        this._updateLang();
        this._checkPrivate();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({
            lang: langRegister.lang()
        });
    }

    _updateLayout() {
        try {
            this.setState({layout: this.props.layout});
        } catch (e) {}
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateLanguages(){
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            this.setState({private: salesChannelRegister.get("private")});
        }
    }

    _signout() {
        if(this.state.user){
            if(this.state.user.admin){
                this.setState({home: true, leave: true});
            }else{
                userRegister.remove();
                tokenRegister.remove();
                agentRegister.remove();
                window.location.reload();
            }
        }else{
            userRegister.remove();
            tokenRegister.remove();
            agentRegister.remove();
            window.location.reload();
        }
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _open(option) {
        this.state.options[option] = !this.state.options[option];
        this.setState({options: this.state.options});
    }

    _signup() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
            this._closeMenu();
        } catch (e) {}
    }

    _profile() {
        if (this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1) {
            this.setState({leave: true, profile: true});
        }else{
            try {
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
                this._closeMenu();
            } catch (e) {}
        }
    }

    _login() {
        try{
            if(this.props.props.location.pathname.indexOf("login") !== -1){
                this._closeMenu();
            }else{
                if(this.props.props.location.pathname.indexOf("signup") !== -1){
                    if(!this.state.private){
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login" + "?from_path=" + this.props.props.location.pathname);
                    }else{
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
                    }
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
                }
            }
        }catch (e) {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
        }
    }

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("image") !== -1){
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                window.location.reload();
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(prop.toLowerCase() !== langRegister.lang().toLowerCase()){
            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                this.setState({language: true, temp_lang: prop, dropdown: false});
            }else{
                let string = "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name');
                let re = new RegExp(string,"g");
                let url = this.props.props.location.pathname.replace(re,'');
                langRegister.set(prop);
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + url);
                window.location.reload();
            }
        }else{
            this.setState({dropdown: false});
        }
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    if(this.state.temp_option){
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + this.state.temp_option);
                    }else{
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                    }
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("image") !== -1){
                    window.location.reload();
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _terms(value){
        window.open('https://legal.'+dataRegister.domain+"/"+ salesChannelRegister.get('market') + "/" + langRegister.lang() + "/"+value+"/" + salesChannelRegister.get('name'), '_blank');
    }

    _help(){
        window.open('https://help.'+dataRegister.domain+"/"+ salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderText(item) {
        return langRegister.get("mobile-menu", item);
    }

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    {
                        this.state.language &&
                        <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                    }
                    {
                        this.state.leave &&
                        <ModalLeave setLeave={this._leave} props={this.props}/>
                    }
                    {
                        this.state.video &&
                        <ModalVideo setVideo={this._setVideo} props={this.props}/>
                    }
                    <div className={Styles.menuInner}>
                        <img onClick={() => this._home()} className={Styles.menuInnerLogo}
                             src={salesChannelRegister.get('logo_mobile')}/>
                        {
                            !this.state.layout &&
                            <img className={Styles.menuInnerFigure}
                                 src={require("../../assets/images/figure_mobile_one.png")}/>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_yl.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this._profile()} className={Styles.menuInnerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller_yl.svg")}/>
                        }
                        <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose}
                             src={require("../../assets/images/cross_icon.png")}/>
                        <div className={Styles.menuInnerOptions}>
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item, key) => {
                                            return(
                                                <option key={key} value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>
                            {
                                !this.state.private &&
                                <div onClick={() => this._signup()} className={Styles.button}>
                                    {this._renderText("item_11")}
                                </div>
                            }
                            {
                                this.state.user.email &&
                                <div onClick={() => this._signout()} className={Styles.button}>
                                    {this._renderText("item_12")}
                                </div>
                            }
                            {
                                !this.state.user.email &&
                                <div onClick={() => this._login()} className={Styles.button}>
                                    {this._renderText("item_13")}
                                </div>
                            }
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_14")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_15")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_16")}</span>
                            </div>
                            <div style={{width: "100%", height: "200px"}}/>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default HeaderMobileMenu;


// WEBPACK FOOTER //
// ./src/components/header-mobile-menu/component.js